import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { NavigationDrawer } from 'react-md';
import NavLink from './components/NavLink';
import UserMenu from './components/UserMenu';
import DrawerHeader from './components/DrawerHeader';
import { logout } from './common/auth'
import logo from './assets/img/logo.png';
import { TextField as Text } from '@material-ui/core/TextField';
import Clientes from './views/clientes/Clientes';
import GraficoMaiorSaida from './views/grafico-maior-saida/GraficoMaiorSaida';
import Login from './views/login/Login';
import Itens from './views/itens/Itens';
import PedidosHome from './views/pedidos/PedidosHome'
import Profile from './views/profile/Profile';
import Relatorio from './views/relatorio/Relatorio';
import Usuarios from './views/usuarios/Usuarios';

const navItems = [
    { label: 'Clientes', to: '/clientes', icon: 'account_box' }, 
    { label: 'Itens', to: '/itens', icon: 'note_add' }, 
    { label: 'Pedidos', to: '/pedidos/lista', icon: 'add_shopping_cart' }, 
    { label: 'Itens com maior saída', to: '/graficos-maior-saida', icon: 'pie_chart' }, 
    { label: 'Relatório', to: '/relatorio', icon: 'library_books' }, 
    { label: 'Usuários', to: '/usuarios', icon: 'account_circle' }, 
];

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            localStorage.getItem('accessToken') ? (
                <Component {...props} />
            ) :  (
                <Redirect
                    to={{
                        pathname: "/login",
                        state: { from: props.location }
                    }}
                />
            )
        }
    />
);

class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
        }
    }    

    componentDidMount() {
        
    }

    render() {
 
        return (
            localStorage.getItem('accessToken') ?
                <Route
                    render={({ location }) => (
                        <NavigationDrawer 
                            mobileDrawerType={NavigationDrawer.DrawerTypes.TEMPORARY_MINI}
                            tabletDrawerType={NavigationDrawer.DrawerTypes.PERSISTENT_MINI}
                            desktopDrawerType={NavigationDrawer.DrawerTypes.FULL_HEIGHT}
                            drawerHeader={ <DrawerHeader logo={logo} title="GESTÃO DE PEDIDOS"/>}
                            toolbarActions={ <UserMenu onLogout={this.handleLogout} onEdit={this.handleEdit}/> }
                            navItems={navItems.map(props => <NavLink {...props} key={props.to} />)} 
                            toolbarClassName="tw-nav"
                            drawerClassName="tw-drawer"
                            >
                            <Switch key={location.key}>
                                <PrivateRoute exact path="/clientes" location={location} component={Clientes} />
                                <PrivateRoute path="/pedidos/lista" location={location} component={PedidosHome} />
                                <PrivateRoute path="/relatorio" location={location} component={Relatorio} />
                                <PrivateRoute path="/graficos-maior-saida" location={location} component={GraficoMaiorSaida} />
                                <PrivateRoute path="/itens" location={location} component={Itens} />
                                <PrivateRoute path="/perfil" location={location} component={Profile} />
                                <PrivateRoute path="/usuarios" location={location} component={Usuarios} />
                            </Switch>
                        </NavigationDrawer>
                    )}
                /> :  
                <Route
                    render={({ location }) => (
                        <Switch key={location.key}>
                            <Route exact path="/" location={location} component={Login} />
                            <Route path="/login" location={location} component={Login} />
                            
                        </Switch>
                    )}
                />
        );
    }

    handleLogout = event => {
        logout();
        window.location.href='/login';
    }

    handleEdit = () => {
        window.location.href='/perfil';
    }

    toggleMenu = () => {
        let menuVisible = !this.state.menuVisible;
        this.setState({menuVisible});
    }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js